import { render, staticRenderFns } from "./ConfiguracoesPage.vue?vue&type=template&id=1989e0b5&scoped=true"
import script from "./ConfiguracoesPage.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesPage.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesPage.vue?vue&type=style&index=0&id=1989e0b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1989e0b5",
  null
  
)

export default component.exports